import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { createModal, useModalize } from '@/components/modalize/mui'
import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import { Button } from '@/components/button'
import { CautionIcon } from '@/components/icons'
import { Row } from '../styles'

// Styled Components
const Wrapper = styled.div`
  display: flex;
  background: ${colors.white};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  gap: 16px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 5%;
  }
`

const Title = styled.h1`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  text-align: center;
  line-height: 32px;
`

const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
`

type Props = {
  handleToggleHidden?: any
  onClose?: any
  client?: any
  onlyWarning?: boolean
}

const HideListing = ({ handleToggleHidden, onClose, client, onlyWarning }: Props) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  const handleHideListing = () => {
    handleToggleHidden()
    client.invalidateQueries({ queryKey: ['sponsored-listings'] })
    onClose()
    close()
  }

  return (
    <Wrapper>
      <CautionIcon width={70} />
      <Title>
        {t(
          'l.boost_listing.hide_listing.modal.title',
          'Are you sure you want to hide this listing?'
        )}
      </Title>
      <Subtitle>
        {t(
          'l.boost_listing.hide_listing.modal.subtitle',
          'Hiding this listing will prevent it from being sponsored. If it is currently sponsored, it will be removed.'
        )}
      </Subtitle>

      <Row style={{ gap: '16px', marginTop: '8px' }}>
        <Button width="100%" onClick={close} theme={'secondary'}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button width="100%" onClick={handleHideListing}>
          {onlyWarning
            ? t('common.continue', 'Continue')
            : t('l.boost_listing.hide_listing.modal.hide', 'Hide listing')}
        </Button>
      </Row>
    </Wrapper>
  )
}

export const showHideListing = createModal(HideListing, {
  width: 'auto',
  maxWidth: '435px',
  showBackground: false,
  showClose: true,
  hasHeader: false,
  radius: '16px',
  sheet: true
})
